import { CommitDiffQueryType, commitDiffQuery, GitDiffResponse } from '@common/queries/git';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';

import { useGraphQlMutation } from '../../data/util';
import { useGitQueryDefaultErrorHandler } from './useGitQueryDefaultErrorHandler';

export const useCommitDiff = (projectId: string, branchName: string) => {
  const onError = useGitQueryDefaultErrorHandler(projectId);
  const { mutateAsync, isLoading: isInitialLoading } = useGraphQlMutation<
    CommitDiffQueryType,
    { projectId: string; currentCommit: string; previousCommit: string; branchName: string }
  >(commitDiffQuery, { onError: onError });

  const getDiff = usePersistentCallback(
    async (currentCommit: string, previousCommit: string): Promise<GitDiffResponse> => {
      const diffVariables = { projectId, currentCommit, previousCommit, branchName };
      const diffResult = await mutateAsync(diffVariables);
      return diffResult.GitDiff as GitDiffResponse;
    }
  );
  return { getDiff, isInitialLoading };
};
